declare const window: any;
//import all styles
import "./legacy/styles/viewer_styles.css";
import "./legacy/styles/measuringTool.css";
import "./legacy/styles/keyboard-shortcuts.css";
import "./legacy/scripts/main_viewer.js";
import "@progress/kendo-ui";
import { createApp } from "vue";
import App from "./App.vue";
import store from "./store";
import router from "./router/router";
import i18n from "./i18n";

window.app = createApp(App).use(i18n).use(router).use(store).mount("#app");
